import { html, css } from 'lit-element';
// import { Chart } from '../Chart';
import { Chart } from 'chart.js';
import { BaseElement } from './BaseElement';
import { PatientProgressData } from '../PatientProgressData';
import { PainResponse } from '../PainResponse';
import toUTCLocaleDateString from '../toUTCLocaleDateString';

Chart.platform.disableCSSInjection = true;

const _data = Symbol();
const _resizeHandler = Symbol();
const _chart = Symbol();

class PainChart extends BaseElement {
	constructor() {
		super();

		this[_resizeHandler] = () => {
			if(this.chart) {
				this.chart.resize();
				this.chart.render();
			}
		};
	}
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				:host {
					overflow: hidden;
				}
				canvas {
					width: 100%;
					height: 100%;
				}
				p {
					text-align: center;
					border: var(--theme-border, black);
					border-radius: 0.25em;
					padding: 0.25em;
					margin: 0.25em;
				}
			`
		];
	}
	get canvas() {
		return this.shadowRoot.querySelector('canvas');
	}
	get chart() {
		return this[_chart];
	}
	get data() {
		return this[_data];
	}
	set data(v) {
		if(v !== null && !(v instanceof PatientProgressData))
			throw new TypeError('data must be an instance of PatientProgressData.');
		this[_data] = v;
		this.requestUpdate();
		setTimeout(() => this.drawChart(), 0);
	}
	firstUpdated() {
		super.firstUpdated();
		this.drawChart();
	}
	connectedCallback() {
		super.connectedCallback();

		this.window.addEventListener('resize', this[_resizeHandler]);
	}
	disconnectedCallback() {
		this.window.removeEventListener('resize', this[_resizeHandler]);

		super.disconnectedCallback();
	}
	drawChart() {
		if(!this.data || !this.data.lastDay)
			return;
		
		const painResponseDays = [...this.data.painResponses];
		let allDays = [];
		let date = new Date(this.data.firstDay);
		
		while(date.getTime() <= this.data.lastDay) {
			const painResponse = painResponseDays.find(v => v.answerDate === date.getTime());
			allDays.push(painResponse || PainResponse.fromObject({ answerDate: date.getTime() }));
			date.setUTCDate(date.getUTCDate() + 1);
		}

		const datasets = [
			{
				label: 'Pain Level',
				data: allDays.map(v => v.value),
				backgroundColor: [
					'rgba(255, 0, 0, 0.1)'
				],
				borderColor: [
					'rgba(255, 0, 0, 1)'
				],
				borderWidth: 2,
				fill: true,
				spanGaps: false,
				pointBorderColor: 'rgba(255, 0, 0, 1)'
			}
		];
		
		this[_chart] = new Chart(this.canvas, {
			type: 'line',
			data: {
				labels: allDays.map(v => toUTCLocaleDateString(new Date(v.answerDate))),
				datasets
			},
			options: {
				tooltips: {
					bodyFontSize: 16,
					titleFontSize: 16
				},
				scales: {
					yAxes: [{
						ticks: {
							beginAtZero: true,
							fontSize: 16,
							suggestedMax: 10
						},
						
					}],
					xAxes: [
						{
							ticks: {
								fontSize: 16
							}
						}
					]
				},
				legend: {
					labels: {
						fontSize: 16
					}
				},
				hover: {
					animationDuration: 0
				},
				responsive: false,
				animation: {
					duration: 0
				}
			}
		});
	}
	render() {
		const showCanvas = this.data && this.data.painResponses.lastDay;
		return html`
			<canvas class="${showCanvas ? '' : 'no-display'}"></canvas>
			<p class="${!showCanvas ? '' : 'no-display'}">
				No pain response data available.
			</p>
		`;
	}
}

customElements.define('pp-pain-chart', PainChart);